import React, { useState } from "react";

/* ── Confirmación dentro del panel ───────────────────────────────────────────
 *
 * 🔴 `window.confirm` NO SIRVE ACÁ. En el navegador de Carlos no abre ningún cartel y
 * devuelve `false` directo, así que todo `if (!window.confirm(...)) return;` cancela solo:
 * la operación queda imposible de completar y el usuario ve un "cancelado" que él no pidió.
 * Medido el 2026-09-16 intentando quitar la ruta por defecto de Denwa — el backend pedía su
 * confirmación, el reintento nunca salía y no había forma de apagarla desde la pantalla.
 *
 * Además el `confirm` del sistema no respeta el tema del panel y renderiza pésimo los textos
 * largos que manda el backend (los del guardia de ruteo son párrafos enteros).
 *
 * Uso — el call site queda igual que antes, sólo agrega `await`:
 *
 *     const [confirmar, dialogoConfirm] = useConfirm();
 *     ...
 *     if (!(await confirmar("¿Borrar esto?"))) return;
 *     ...
 *     return (<div> ... {dialogoConfirm} </div>);
 *
 * ⚠️ Quedan 12 componentes más usando `window.confirm` (Usuarios, ClientesV2, DIDSeries,
 * Billing, Permissions, …): ahí cada confirmación destructiva se está cancelando sola del
 * mismo modo. Migrarlos a este hook es mecánico.
 */

export function ConfirmDialog({ texto, onSi, onNo, textoSi = "Sí, continuar" }) {
  return (
    <div style={{
      position:"fixed", inset:0, background:"rgba(0,0,0,.45)", zIndex:1000,
      display:"flex", alignItems:"center", justifyContent:"center", padding:20,
    }} onClick={onNo}>
      <div onClick={e=>e.stopPropagation()} style={{
        background:"var(--bg-panel, var(--bg-void))", border:"1px solid var(--border)",
        borderRadius:8, padding:20, maxWidth:560, width:"100%",
        boxShadow:"0 10px 40px rgba(0,0,0,.35)",
      }}>
        <div style={{ fontSize:13, lineHeight:1.55, color:"var(--fg)", whiteSpace:"pre-wrap" }}>
          {texto}
        </div>
        <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:18 }}>
          <button className="nv-btn nv-btn-ghost" onClick={onNo}>Cancelar</button>
          <button className="nv-btn" onClick={onSi} autoFocus>{textoSi}</button>
        </div>
      </div>
    </div>
  );
}

export function useConfirm() {
  const [pedido, setPedido] = useState(null);   // { texto, resolve }
  const confirmar = (texto) => new Promise(resolve => setPedido({ texto, resolve }));
  const responder = (ok) => {
    if (pedido) pedido.resolve(ok);
    setPedido(null);
  };
  const dialogo = pedido
    ? <ConfirmDialog texto={pedido.texto} onSi={()=>responder(true)} onNo={()=>responder(false)}/>
    : null;
  return [confirmar, dialogo];
}
